import React from 'react'
import { groupBy } from 'lodash-es'
import { Translation, Locale } from 'locale'
import { CollateralStatus, CollateralDetail } from 'api'
import { HeroPanel, BannerStatusTile, BannerTilesGroup, DetailTilesContainer, EnvironmentTitle } from 'view/shared/heroPanel'

interface CollateralHeroPanelProps {
  collateralList: CollateralDetail[]
  onTearout: () => void
}

export const CollateralHeroPanel: React.FunctionComponent<CollateralHeroPanelProps> = props => {
  const { collateralList, onTearout } = props
  const collateralsByStatus = groupBy(collateralList, orgDetail => orgDetail.collateral.status)

  const statusToMetricLabelMap: [CollateralStatus, Translation][] = [
    [CollateralStatus.ENABLED, Translation.TC_ACTIVE],
    [CollateralStatus.DISABLED, Translation.TC_SUSPENDED],
    [CollateralStatus.PENDING, Translation.TC_PENDING],
    [CollateralStatus.PENDING_FAILED, Translation.TC_PENDING_FAILED],
    [CollateralStatus.PENDING_AWAITING_PRICE, Translation.TC_PENDING_AWAITING_PRICE]
  ]

  return (
    <HeroPanel onTearout={onTearout}>
      <DetailTilesContainer>
        <EnvironmentTitle data-test-id={'CollateralHeroPanel-EnvironmentTitle'}>
          {Locale.translate(Translation.TC_HERO_COLLATERALS)}
        </EnvironmentTitle>
        <BannerTilesGroup title={Locale.translate(Translation.TC_HERO_SUMMARY)}>
          <BannerStatusTile title={Locale.translate(Translation.TC_TOTAL)} label={collateralList.length} />
          {statusToMetricLabelMap.map(([status, translation]) => (
            <BannerStatusTile key={status} title={Locale.translate(translation)} label={(collateralsByStatus[status] ?? []).length} />
          ))}
        </BannerTilesGroup>
      </DetailTilesContainer>
    </HeroPanel>
  )
}
